export default __webpack_public_path__ + "static/media/04.adfc75b5.jpg";